import { simplePath } from "../utils.js";
const GET_USER_PINS_PATH = '/v2/pins/user/:user';
const GET_APPLICATION_LIST_PINS_PATH = "/v2/user-pin/:user/pinned-applications";
function get_user_pins_path(params) {
    return simplePath(GET_USER_PINS_PATH, params);
}
function get_application_list_pins_path(params) {
    return simplePath(GET_APPLICATION_LIST_PINS_PATH, params);
}
export { GET_APPLICATION_LIST_PINS_PATH, GET_USER_PINS_PATH, get_application_list_pins_path, get_user_pins_path };
